import { useEffect, useEffectEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { Sheet, useUrlSheet } from "@/shared/ui";
import { LOGIN_SHEET, takePendingAction } from "../model/useRequireLogin";
import { useSession } from "../model/useSession";
import { LoginForm } from "./LoginForm";

/**
 * Login over the current page (D31): mounted once in the shop layout, opened by `useRequireLogin` through
 * `?sheet=login`. After the code the sheet closes and the waiting action continues (checkout, payment).
 */
export function LoginSheet() {
  const { t } = useTranslation("auth");
  const [open, setOpen] = useUrlSheet(LOGIN_SHEET);
  const [search, setSearch] = useSearchParams();
  const { status } = useSession();
  const finish = () => {
    // replace, not back: the waiting action may navigate right away
    const params = new URLSearchParams(search);
    params.delete("sheet");
    setSearch(params, { replace: true, preventScrollReset: true });
    takePendingAction()?.();
  };
  const finishOnSignIn = useEffectEvent(finish);

  useEffect(() => {
    if (!open) {
      // closed without signing in (✕, Back): the action must not run after some later login
      if (status !== "authenticated") takePendingAction();
      return;
    }
    // signed in some other way while the sheet was open (the Telegram sign-in at startup)
    if (status === "authenticated") finishOnSignIn();
  }, [open, status]);

  return (
    <Sheet open={open} onOpenChange={setOpen} title={t("sheetTitle")} size="tall" focusInput>
      {open && (
        <div className="flex flex-col gap-4 pt-1">
          <p className="text-body-lg text-muted">{t("sheetHint")}</p>
          <LoginForm
            onSignedIn={() => {
              // the effect above continues the waiting action once the session is signed in
            }}
          />
        </div>
      )}
    </Sheet>
  );
}
